module.exports = __webpack_public_path__ + "static/media/homeBroker.a4eb4340.svg";